const FEATURE_CARDS = [
  {
    image: "/educator-assets/c1.webp",
    title: "فروش قسطی",
    description:
      "با انتشار دوره های خود در ویترین آموزیم، هنرآموزان شما می توانند دوره های شما را به صورت قسطی تهیه کنند اما مبلغ آن به صورت آنی به کیف پول شما واریز می گردد.",
  },
  {
    image: "/educator-assets/c2.webp",
    title: "برنامه اختصاصی",
    description:
      "با ورود به آموزیم، برنامه اختصاصی شما در ایتا ساخته می شود، این برنامه کاملا اختصاصی و برای شماست.",
  },
  {
    image: "/educator-assets/c3.webp",
    title: "کاربر آماده برای خرید",
    description:
      "دوره های شما در ویترین برای میلیون ها کاربر ایتایی و اسنپ نمایش داده می شود.",
  },
] as const;

export default function EducatorsFeatureCardsSection() {
  return (
    <section className="px-[18px] pb-10 pt-1">
      <div className="flex flex-col gap-5">
        {FEATURE_CARDS.map((card, index) => (
          <article
            key={card.title}
            id={`educators-feature-${index}`}
            className="scroll-mt-4 rounded-3xl bg-background shadow-sm p-2 pb-4 text-center"
          >
            <img
              src={card.image}
              alt={card.title}
              className="aspect-[2/1] w-full rounded-2xl object-cover"
            />
            <h2 className="mt-3 text-base font-extrabold leading-6 text-foreground">
              {card.title}
            </h2>
            <p className="mt-3 px-2 text-sm leading-7 text-default-700">
              {card.description}
            </p>
          </article>
        ))}
      </div>
    </section>
  );
}
